module.exports = __webpack_public_path__ + "media/entities/1106-f7e00982.png";